<script>
    export let primary = false;
    export let secondary = false;
    export let platform = false;
    export let selected = false;
    export let emoji;
    export let text;
    export let position = "left";
    export let disabled;
    export let buttonType = "button";
    export let onClick;

    $: selectedColor = selected ? "#fd7d3e" : "#E7E7E7";
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    button {
        text-align: center;
        position: relative;
        padding: var(--spacer-tiny) var(--spacer-medium);
        border-radius: 6px;
        margin-top: 0;
        box-shadow: var(--small-box-shadow);
        float: var(--position);
        height: 42px;

        &:hover {
            cursor: pointer;
        }

        &:enabled:active {
            margin-top: 4px;
        }

        &:enabled:active:after {
            bottom: 0;
        }

        &:after {
            position: absolute;
            border-radius: 6px;
            bottom: -4px;
            content: "";
            left: 0;
            right: 0;
            top: 0;
            z-index: -1;
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

    p {
        font-size: var(--font-regular);
        font-weight: var(--weight-bold);
        color: var(--color-white);
    }

    .primary {
        background-color: var(--color-orange);

        &:hover {
            background-color: #ff5319;
        }

        &:after {
            background-color: #ee3b00;
        }
    }

    .secondary {
        background-color: #f8f8f8;

        p {
            color: rgba(22, 12, 40, 0.6);
        }

        &:hover {
            background-color: #fcfcfc;
        }

        &:after {
            background-color: #d6d6d6;
        }
    }

    .platform {
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: var(--color-white);
        width: 72px;

        &:after {
            background-color: var(--selected-color);
            border-radius: 8px;
        }

        @include sm {
            width: 160px;
            height: 62px;
            flex-direction: row;
            align-items: center;
        }

        img {
            width: 30px;
            height: 30px;
            user-select: none;

            @include sm {
                width: 35px;
                height: 35px;
                margin-right: var(--spacer-tiny);
            }
        }

        p {
            font-size: var(--font-small);
            font-weight: var(--weight-regular);
            color: var(--color-black);

            @include sm {
                font-size: var(--font-regular);
                font-weight: var(--weight-medium);
                color: rgba(22, 12, 40, 0.6);
            }
        }
    }

    .under-development {
        position: absolute;
        width: 100%;
        background-color: rgba(243, 227, 0, 0.822);
        border-radius: 8px 8px 0 0;
        top: 0;

        p {
            font-size: var(--font-small);
            padding: 2px;
            text-align: center;
        }
    }
</style>

{#if platform}
    <button
        class="platform"
        class:selected
        on:click={onClick}
        {disabled}
        style="--selected-color: {selectedColor}">
        {#if disabled}
            <div class="under-development">
                <p>Coming Soon!</p>
            </div>
        {/if}

        <img
            alt={emoji}
            src={'emojis/' + emoji}
            type="image/svg+xml"
            draggable="false" />
        <p>{text}</p>
    </button>
{:else}
    <button
        class:primary
        class:secondary
        {disabled}
        on:click={onClick}
        type={buttonType}
        style="--position:{position};">
        <p>{text}</p>
    </button>
{/if}
